import {ISimilar} from 'modules/product-card/models/ProductResponse';
import {ProductCard} from 'components/ProductCard';
import {Typography} from 'components/Typography';
import style from './style.module.scss';

type TProductSimilarBlockProps = Pick<ISimilar, 'product' | 'type'>;

const TITLES_MAP = {
    vintage: 'Нашли такой же',
    offer: 'Нашли замену',
};

export const ProductSimilarBlock = (props: TProductSimilarBlockProps) => {
    const {product, type} = props;
    const title = TITLES_MAP[type] ?? '';

    if (!title) {
        return null;
    }

    return (
        <div className={style.similarMain} id={'similar'}>
            {title && (
                <Typography
                    variants={{DT: 'title-20-m', TB: 'title-20-m', MB: 'title-20-m'}}
                    className={style.similarTitle}
                    element={'span'}
                >
                    {title}
                </Typography>
            )}
            <div className={style.similarProductWrapper}>
                <ProductCard product={product} withPadding={false} />
            </div>
        </div>
    );
};
